interface DataType {
  id: number;
  sub_title: string;
  title: string;
  desc: React.ReactNode;
}

const road_map_data: DataType[] = [
  {
    id: 1,
    sub_title: "01. Create Your Free Account",
    title: "Sign up & Verify",
    desc: (
      <>
        Get started in a few clicks. No complex verification processes. Provide
        an email and a secure password. Proceed to verify your email to activate
        your profile.
      </>
    ),
  },
  {
    id: 2,
    sub_title: "02. Setup Withdrawal Account",
    title: "Withdrawal Account",
    desc: (
      <>
        Add your favourtie bank account for withdrawals. You can add as many
        bank accounts as you desire for seamleass withdrawals.
      </>
    ),
  },
  {
    id: 3,
    sub_title: "03. Set Up Your Security Pin",
    title: "Set Security Pin",
    desc: (
      <>
        Secure your account and withdrawals with a 4 digit withdrawal pin to
        prevent unauthorized withdrawals access on your account.
      </>
    ),
  },
  {
    id: 4,
    sub_title: "04. Initiate Your First Trade",
    title: "Sell Crypto",
    desc: (
      <>
        Select the crypto to sell, enter an amount and a wallet address will be
        generated. Send crypto to the wallet. Once confirmed, the Naira
        equivallent will be credited to your Naira Wallet.
      </>
    ),
  },
  {
    id: 5,
    sub_title: "05. Withdraw To Your Bank Account",
    title: "Withdraw Funds",
    desc: (
      <>
        Proceed to withdraw your funds from your Naira wallet to any of your
        preferred bank accounts in seconds. It’s that simple!
      </>
    ),
  },
];

export default road_map_data;
